import { Avatar, Text } from "@/elements"
import { FragmentType, graphql, useFragment } from "@/gql"
import { JobTitleColorisedWithNameAndImageFragmentDoc } from "@/gql/graphql"
import { TextColor, TextVariant } from "@/theme"
import { JobTitleColorised } from "@/components/JobTitleColorised"

graphql(`
  fragment JobTitleColorisedWithNameAndImage on JobPosting {
    id
    __typename
    ...JobTitleColorised
    owner {
      id
      __typename

      ... on IndividualClient {
        name

        user {
          avatar(width: 120)
          avatarInitials
          name
        }
      }

      ... on IndividualCreative {
        name
        user {
          avatar(width: 120)
          avatarInitials
        }
      }

      ... on User {
        avatar(width: 120)
        avatarInitials
        name
      }
    }
  }
`)

interface Props {
  jobPost: FragmentType<typeof JobTitleColorisedWithNameAndImageFragmentDoc> | null | undefined
  commonWordColor?: TextColor
  focusWordColor?: TextColor
  textVariant?: TextVariant
  maxLines?: number | undefined
}

export const JobTitleColorisedWithNameAndImage: React.FC<Props> = ({ ...props }) => {
  const jobPost = useFragment(JobTitleColorisedWithNameAndImageFragmentDoc, props.jobPost)

  const user = jobPost?.owner?.__typename === "User" ? jobPost.owner : null
  const creative = jobPost?.owner?.__typename === "IndividualCreative" ? jobPost.owner : null
  const client = jobPost?.owner?.__typename === "IndividualClient" ? jobPost.owner : null

  const avatar = user?.avatar || creative?.user?.avatar || client?.user?.avatar
  const avatarInitials = user?.avatarInitials || creative?.user?.avatarInitials || client?.user?.avatarInitials
  const name = creative?.name || client?.name || user?.name

  return (
    <Text element="p">
      {avatar ? (
        <Text element="span" className="mb-[-10px] mr-1 inline-flex items-center">
          <Avatar size="2xs" className="bottom-[-3px] shrink-0" src={avatar} initials={avatarInitials} />
        </Text>
      ) : null}
      <Text element="span" className="">
        {name} needs a
      </Text>
      <div className="ml-1 inline">
        <JobTitleColorised className="inline" {...props} jobPost={jobPost} />
      </div>
    </Text>
  )
}
